module.exports = __webpack_public_path__ + "img/login_vk.6fcbf0af.svg";